import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	useTheme,
	useMediaQuery,
	Grid,
	FormControlLabel,
	Checkbox,
	IconButton,
	InputAdornment,
	TextField
} from '@material-ui/core';

import FilterField from "../components/FilterField";
import SourceFilterField from "../components/SourceFilterField";
import AccountFilterField from "../components/AccountFilterField";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CategoriesFilter from './CategoriesFilter';

const styles = makeStyles(theme => ({
	filterGrid: {
		[theme.breakpoints.up('sm')]: {
			maxHeight: theme.spacing(4)
		}
	},

	showDeletedItem: {
		paddingLeft: theme.spacing(1),
		paddingBottom: theme.spacing(0.25)
	},

	showDeletedCheckBox: {
		marginRight: 0
	},

	fieldStyle: {
		border: `1px solid ${theme.palette.secondary.lightGrey}`,
		backgroundColor: 'transparent',
		borderRadius: "10px",
		marginRight: "20px",
	},

	searchField: {
		width: "100%",
		borderRadius: "12px",
		border: `1px solid ${theme.palette.primary.lightGrey}`,
		margin: 0,
		[theme.breakpoints.down('md')]: {
			marginTop: 30,
		},

		"& input": {
			padding: "10px 0px",
			color: theme.palette.secondary.grey,
		},
	},

	searchIcon: {
		paddingLeft: theme.spacing(1),
	},
}));

function InboxFilters(props) {
	const theme = useTheme();
	const classes = styles();
	const atLeastSM = useMediaQuery(theme.breakpoints.up("sm"));
	const [searchValue, setSearchValue] = useState('');
	const debounceTimeout = useRef(null);

	let { showRemovedCheckbox, showRemovedChecked, showRemovedHandler,
		categoryOptions, accountOptions, sourceOptions, topicOptions,
		categoryFilterHandler, sourceFilterHandler, accountFilterHandler, topicFilterHandler, stickyFilterHandler,
		isFreemium, freemiumUpgradeHandler } = props;

	const clearClicked = () => {
		setSearchValue("");

		if (props.clearTextHandler) {
			props.clearTextHandler();
		}
	};

	const handleSearchChange = (event) => {
		const value = event.target.value;
		setSearchValue(value);

		if (debounceTimeout.current) {
			clearTimeout(debounceTimeout.current);
		}

		debounceTimeout.current = setTimeout(() => {
			props.searchTextHandler(value);
		}, 1000);
	};

	return (
		<Grid
			container
			alignItems={!atLeastSM ? "flex-end" : null}
			justify={atLeastSM ? "space-between" : "flex-start"}>
			<Grid item>
				<Grid
					container
					alignItems="center"
					className={classes.filterGrid}>
					<Grid item>
						<AccountFilterField
							includeReset={atLeastSM}
							accountOptions={accountOptions}
							changeHandler={accountFilterHandler}
							stickyFilterHandler={stickyFilterHandler} />
					</Grid>
					<Grid item className={classes.fieldStyle}>
						{/* <FilterField
							includeSelectAll
							includeReset={atLeastSM}
							options={categoryOptions}
							name="category"
							menuTitle="Categories"
							selectAllTitle="All Categories"
							changeHandler={categoryFilterHandler}
							startIcon={<FontAwesomeIcon icon={["fal", "signal"]} transform={{ rotate: 270 }} />} /> */}
						<CategoriesFilter changeHandler={categoryFilterHandler} options={categoryOptions} />
					</Grid>
					<Grid item className={classes.fieldStyle}>
						<SourceFilterField
							includeReset={atLeastSM}
							sourceOptions={sourceOptions}
							changeHandler={sourceFilterHandler}
						/>
					</Grid>
					<Grid item className={classes.fieldStyle}>
						<FilterField
							includeSelectAll
							includeReset={atLeastSM}
							singleColumn={!atLeastSM}
							options={topicOptions}
							name="topic"
							menuTitle="Topics"
							selectAllTitle="All Topics"
							changeHandler={topicFilterHandler}
							buttonText="UPGRADE"
							displayButton={isFreemium}
							buttonHandler={freemiumUpgradeHandler}
							startIcon={<FontAwesomeIcon icon={["fal", "signal"]} transform={{ rotate: 270 }} />} />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<TextField
					name="search"
					placeholder="Search"
					onChange={handleSearchChange}
					className={`${classes.searchField}`}
					value={searchValue}
					margin="normal"
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<FontAwesomeIcon icon={["fal", "search"]} size="md" title="search" className={`${classes.searchIcon}`} />
							</InputAdornment>
						),
						endAdornment: (
							<InputAdornment position="end">
								<IconButton aria-label="clear" onClick={clearClicked}>
									<FontAwesomeIcon icon={["fal", "times"]} size="xs" title="clear" />
								</IconButton>
							</InputAdornment>
						),
						disableUnderline: true
					}}
				/>
			</Grid>
			{showRemovedCheckbox ?
				<Grid item className={classes.showDeletedItem}>
					<FormControlLabel
						label="Include Removed"
						control={
							<Checkbox
								color="secondary"
								checked={showRemovedChecked}
								onChange={showRemovedHandler}
								classes={{ root: classes.showDeletedCheckBox }} />
						} />
				</Grid> : null
			}
		</Grid>
	);
}

InboxFilters.propTypes = {
	categoryFilterHandler: PropTypes.func.isRequired,
	sourceFilterHandler: PropTypes.func.isRequired,
	accountFilterHandler: PropTypes.func.isRequired,
	topicFilterHandler: PropTypes.func.isRequired,
	stickyFilterHandler: PropTypes.func,
	topicOptions: PropTypes.array,
	categoryOptions: PropTypes.array,
	sourceOptions: PropTypes.array,
	accountOptions: PropTypes.array,
	showRemovedCheckbox: PropTypes.bool,
	showRemovedChecked: PropTypes.bool,
	showRemovedHandler: PropTypes.func,
	isFreemium: PropTypes.bool,
	searchTextHandler: PropTypes.func,
	clearTextHandler: PropTypes.func
};

export default InboxFilters;